<template>
  <div class="tw-p-8">

    <div class="mb-2 tw-text-2xl tw-font-bold">Please review your inputs:</div>

    <table>
      <tr>
        <td class="tw-font-bold tw-text-dark tw-text-opacity-75 tw-p-4">Category:</td>
        <td class="tw-font-bold tw-mr-4 tw-p-4">
          <span>{{_.get(states.category,'title','—')}}</span>
          <button class="tw-inline-block tw-p-1 tw-text-blue tw-font-normal tw-ml-3" v-on:click="gotoStep(1)">edit</button>
        </td>
      </tr>
    
      <tr>
        <td class="tw-font-bold tw-text-dark tw-text-opacity-75 tw-p-4">Suburb:</td>
        <td class="tw-font-bold tw-p-4">
          <span>{{_.get(states.suburb,'name','—')}}</span>
          <button class="tw-inline-block tw-p-1 tw-text-blue tw-font-normal tw-ml-3" v-on:click="gotoStep(2)">edit</button>
        </td>
      </tr>
    
      <tr>
        <td class="tw-font-bold tw-text-dark tw-text-opacity-75 tw-p-4">Description:</td>
        <td class="tw-font-bold tw-mr-4 tw-p-4">
          <span>{{states.description === '' ? '—' : (states.description.split(' ').length <= 20 ? states.description : states.description.split(' ').slice(0,20).join(' ') +'...' )}}</span>
          <button class="tw-inline-block tw-p-1 tw-text-blue tw-font-normal tw-ml-3" v-on:click="gotoStep(3)">edit</button>
        </td>
      </tr>
    
      <tr>
        <td class="tw-font-bold tw-text-dark tw-text-opacity-75 tw-p-4">Execution Time:</td>
        <td class="tw-font-bold tw-mr-4 tw-p-4">
          <span>{{_.get(states.executionTime,'title','—')}}</span>
          <button class="tw-inline-block tw-p-1 tw-text-blue tw-font-normal tw-ml-3" v-on:click="gotoStep(4)">edit</button>
        </td>
      </tr>
      <tr>
        <td class="tw-font-bold tw-text-dark tw-text-opacity-75 tw-p-4">Budget:</td>
        <td class="tw-font-bold tw-mr-4 tw-p-4">
          <span>{{_.get(states.budget,'title','—')}}</span>
          <button class="tw-inline-block tw-p-1 tw-text-blue tw-font-normal tw-ml-3" v-on:click="gotoStep(5)">edit</button>
        </td>
      </tr>
      <tr>
        <td class="tw-font-bold tw-text-dark tw-text-opacity-75 tw-p-4">Attachments:</td>
        <td class="tw-font-bold tw-mr-4 tw-p-4">
          <span>{{attachmentsCount}} file{{attachmentsCount !== 1 ? 's' : ''}} selected</span>
          <button class="tw-inline-block tw-p-1 tw-text-blue tw-font-normal tw-ml-3" v-on:click="gotoStep(6)">edit</button>
        </td>
      </tr>
    </table>

  </div>
</template>
<script>
  import store from './submit-task-store'

  export default {
    beforeCreate() {
      this.store = store
    },
    data: v => ({
      states: store.states,
    }),
    methods: {
      gotoStep(step) {
        store.gotoStep(step)
      }
    },
    computed: {
      attachmentsCount() {
        return this.states.attachments.length + _.get(this.states.task, 'attachments', []).length
      }
    }
  }
</script>
